import { UIMessage, UseChatHelpers } from '@ai-sdk/react';
import { isEmpty } from 'ramda';

import { ConversationStatus } from './useConversation.types';

export const getConversationStatus = (
  loading: boolean | undefined,
  status: UseChatHelpers<UIMessage>['status'],
  messages: unknown[],
): ConversationStatus => {
  if (loading) {
    return 'loading';
  }

  if (status === 'ready' && isEmpty(messages)) {
    return 'initialized';
  }

  return status;
};
